const API_BASE = ("https://api.benchmark.ae/v1").replace(/\/$/, "")

export const API_HOST = API_BASE.replace(/\/v1$/, "")

const cache = {}

async function request(path) {
  if (cache[path]) return cache[path]
  const res = await fetch(`${API_BASE}${path}`)
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const data = res.json()
  cache[path] = data
  return data
}

export const projectsApi = {
  index: ()        => request("/public/projects").then(d => d.projects ?? []),
  show:  (id)      => request(`/public/projects/${id}`).then(d => d.project ?? d),
}

export const servicesApi = {
  index: () => request("/public/services").then(d => d.services ?? []),
  show:  (id) => request(`/public/services/${id}`).then(d => d.service ?? d),
}

export const articlesApi = {
  index: ()        => request("/public/articles").then(d => d.articles ?? []),
  show:  (id)      => request(`/public/articles/${id}`).then(d => d.article ?? d),
}

export const clientsApi = {
  index: ()        => request("/public/clients").then(d => d.clients ?? []),
}